import React, {useContext, useEffect} from "react";
import {ForumContext} from "../../../../context/forumContext";
import LoadingContent from "../../../common/LoadingContent";
import LoadingNoMoreContent from "../../../common/LoadingNoMoreContent";
import {AuthContext} from "../../../../context/authContext";
import Username from "../../../common/Username";
import LazyLoad from "react-lazyload";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEllipsisH, faPlus} from "@fortawesome/free-solid-svg-icons";
import {boardUrl} from "../../../../config/config";
import UserAvatar from "../../../common/UserAvatar";
import {useTranslation} from "react-i18next";
import {Tooltip} from "react-tooltip";

const VideoCreate = ({user}) => {
	return (
		<div className="flex-grow-0 flex-shrink-0">
			<Tooltip id="video-create-tooltip" className="z-50" />

			<li className="text-white flex flex-col items-center space-y-1 relative"
				data-tooltip-id="video-create-tooltip"
				data-tooltip-content={'Đăng bài mới'}
			>
				<div className="bg-url p-1 rounded-full">
					<a className="bg-gray-700 block rounded-full p-1 hover:-rotate-6 transform transition"
					   href={`${boardUrl}/index.php?forums/-/create-thread`}>
						<div className="w-24 h-24">
							<UserAvatar user={user}/>
						</div>
					</a>
				</div>
				<button
					className="absolute bottom-8 right-1 rounded-full h-8 w-8 bg-url text-primary font-semibold border-2 border-white flex justify-center items-center"
				>
					<FontAwesomeIcon icon={faPlus}/>
				</button>

				<Username user={user}/>
			</li>
		</div>
	);
}

const VideoLoadMore = ({hasMoreVideos, loadMoreVideos, videosLoading}) => {
	const {t} = useTranslation();

	if (hasMoreVideos) {
		return (
			<li onClick={loadMoreVideos}
			    className="text-white flex flex-col items-center space-y-1 relative flex-grow-0 flex-shrink-0 cursor-pointer">
				<div className="bg-primary p-1 rounded-full">
					<div className="bg-gray-700 block rounded-full p-1">
						<div className="flex flex-col items-center justify-center w-24 h-24">
							<FontAwesomeIcon icon={faEllipsisH}/>
							{videosLoading ? t('loading_content') : t('load_more')}
						</div>
					</div>
				</div>
			</li>
		);
	}
}

const VideoItem = ({video}) => {
	return (
		<div className="flex-grow-0 flex-shrink-0">
			<Tooltip id={`video-tooltip-${video.attachment_id}`} className="z-50"/>

			<li className="flex flex-col items-center space-y-1"
			    data-tooltip-id="video-create-tooltip"
			    data-tooltip-content={video.thread_title}
			>
				<div className={`${video.Thread.is_unread ? 'bg-gradient-to-tr from-yellow-500 to-fuchsia-600' : 'bg-gray-700'} relative p-1 rounded-full`}>
					{video.Thread.is_unread && (
						<span className="absolute top-0 -right-2 bg-gradient-to-tr from-yellow-500 to-fuchsia-600 px-2 py-1 rounded text-white text-xs font-semibold z-40">
							NEW
						</span>
					)}

					<a className="bg-gray-700 block rounded-full p-1 hover:-rotate-6 transform transition"
					   href={video.view_url} title={video.thread_title}>
						{video.Thread.thumbnail_url ? (
							<LazyLoad className="h-24 w-24">
								<img className="w-full h-full object-cover rounded-full"
								     src={video.Thread.thumbnail_url}
								     alt={video.thread_title}/>
							</LazyLoad>
						) : (
							<div className="w-24 h-24">
								<UserAvatar user={video.User} />
							</div>
						)}
					</a>
				</div>
				<a href={video.view_url} title={video.thread_title} className={`text-sm font-light text-white ${video.Thread.is_unread && 'font-semibold'}`}>
					{video.Thread.username}
				</a>
			</li>
		</div>
	);
}

const VideoList = () => {
	const {visitor} = useContext(AuthContext);
	const {videos, videosLoading, hasMoreVideos, fetchVideos, loadMoreVideos} = useContext(ForumContext);

	useEffect(() => {
		fetchVideos(true);
	});

	if (videos && videos.length > 0) {
		return (
			<div className="max-w-full mx-auto py-4">
				<p className="font-semibold leading-none text-white lg:text-3xl lg:font-extrabold">
					Gái gọi Videos mới
				</p>

				<ul className="flex space-x-6 mt-4 w-full overflow-x-auto">
					{visitor && visitor.user_id && (
						<VideoCreate user={visitor}/>
					)}

					{videos.map((video, index) => (
						<VideoItem key={index} video={video} />
					))}

					<VideoLoadMore
						hasMoreVideos={hasMoreVideos}
						loadMoreVideos={loadMoreVideos}
						videosLoading={videosLoading}
					/>
				</ul>

			</div>
		);
	} else {
		if (videosLoading) {
			return <LoadingContent/>
		} else {
			return <LoadingNoMoreContent/>
		}
	}
}

export default VideoList;